import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { searchService } from "../../services/api/search.service";
import { reportService } from "../../services/api/report.service";
import { utils } from "../../services/helpers/utils";
import { alertService } from "../../services/helpers/alert.service";

export const ContestationsResults = (props) => {

    const { partener, deladata, ladata, cnp, medic_intern, investigatie } = props.params;
    const [consultatii, setConsultatii] = useState(null);
    const navigate = useNavigate();

    const params = {
        partener: partener,
        deLaData: deladata ? utils.convertDate(deladata) : null,
        laData: ladata ? utils.convertDate(ladata) : null,
        cnp: cnp,
        medic: medic_intern,
        serviciul: investigatie
    };


    useEffect(() => {
        if (partener != undefined) {
            searchService.getContestations(params)
                .then(response => {
                    if (response) {
                        setConsultatii(response);
                    }
                    else {
                        setConsultatii([]);
                    }
                });
        }
    }, [props.params]);


    const handleExport = () => {
        if (consultatii.length === 0) {
            alertService.error("Nu exista date pentru export!");
            return;
        }
        reportService.RaportContestatii(params).then((response) => {
            if (response) {
                utils.downloadFile(response, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                return;
            }
        });
    }

    const handleView = (page, param, value) => {

        var encode = {
            partner: partener,
            deLaData: deladata ? utils.convertDate(deladata) : null,
            laData: ladata ? utils.convertDate(ladata) : null,
            cnp: cnp,
            medic: medic_intern,
            serviciul: investigatie
        };

        var encodedString = btoa(JSON.stringify(encode));

        navigate(window.location.hash + `?q=${encodedString}`, { replace: true });
        navigate(`/dashboard/${page}?${param}=${value}`);
    }



    return (
        
        <>
            {consultatii && consultatii.length >= 0 &&
                <>
                    <p className="paragraf">Consultatiile:</p>
                    <table className="tbl" data-name="lista" width="100%">
                        <thead>
                            <tr>
                                <th className="first">Nr</th>
                                <th>Companie</th>
                                <th>Abonament</th>
                                <th>Medic intern</th>
                                <th>Medic trimitator</th>
                                <th>Data ora</th>
                                <th>Serviciul</th>
                                <th>Partener</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {consultatii.map((consultatie, index) => (
                                <tr key={index}>
                                    <td data-name="nr_crt" className="center first"> {index + 1}</td>
                                    <td data-name="nume_firma">{consultatie.companie}</td>
                                    <td data-name="nume_profil">
                                        {consultatie.abonament}
                                        {consultatie.firmaMaster && <span> (</span>}
                                        {consultatie.firmaMaster}
                                        {consultatie.firmaMaster && <span>)</span>}

                                    </td>
                                    <td data-name="nume_medic"> {consultatie.medic}</td>
                                    <td data-name="nume_medic_ext">{consultatie.medicTrimitator}</td>
                                    <td data-name="data_ora" className="center"> {consultatie.dataOra}</td>
                                    <td data-name="serviciul" className="center">{consultatie.serviciu}</td>
                                    <td data-name="partener" className="center">{consultatie.partener}</td>
                                    <td>
                                        <a className="icon deschide"
                                            onClick={() => handleView("consultatie", "consultatie", consultatie.idConsultatie)}
                                            title="Vezi consultatie"
                                            name="view">
                                            Vizualizare
                                        </a>
                                        
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div data-name="export">
                        <button data-name="btn-export-cons" className="btn" onClick={handleExport}>Export</button>
                    </div>
                </>
            }
        </>
    );
};

